import storage from 'redux-persist/lib/storage'
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2'

import coreStore, {
  ApplicationState as CoreApplicationState
} from 'src/core/store'

import { GeneralState } from './ducks/general/types'
import { IntegrationsState } from './ducks/integrations/types'
import { MyTeamState } from './ducks/my-team/types'
import { ReceiptsState } from './ducks/receipts/types'
import { ReportsState } from './ducks/reports/types'
import rootReducer, {
  FILTERS_PERSISTOR,
  WHITE_LIST,
  BLACK_LIST
} from './ducks/rootReducer'
import rootSaga from './ducks/rootSaga'

export type ApplicationState = CoreApplicationState & {
  general: GeneralState
  integrations: IntegrationsState
  myTeam: MyTeamState
  receipts: ReceiptsState
  reports: ReportsState
}

export default coreStore<ApplicationState>({
  dev: process.env.REACT_APP_ENV !== 'production',
  persistConfig: {
    key: 'root',
    storage,
    stateReconciler: autoMergeLevel2,
    blacklist: BLACK_LIST,
    whitelist: WHITE_LIST,
    transforms: FILTERS_PERSISTOR
  },
  reducers: rootReducer,
  sagas: rootSaga
})
